import { z } from "zod";
import { FunctionalRoleArray } from "./company/types.js";
export const CompanyIdentitySchema = z.object({
    name: z.string(),
    email: z.string(),
});
export const UserIdentitySchema = z.object({
    firstName: z.string(),
    lastName: z.string(),
    email: z.string(),
});
// Worker permissions schema
export const WorkerPermissionsSchema = z.object({
    canCreateInvoice: z.boolean(),
    canEditCustomer: z.boolean(),
});
// Zod schema for Context validation
export const ContextSchema = z.object({
    companyId: z.string(),
    companyIdentity: CompanyIdentitySchema,
    memberId: z.string(),
    userId: z.string(),
    userIdentity: UserIdentitySchema,
    fromModeration: z.boolean(),
    role: z.enum(FunctionalRoleArray),
    permissions: WorkerPermissionsSchema,
    churned: z.boolean(),
    churnedAt: z.string().nullable(),
});
//# sourceMappingURL=types.js.map